import Modal from "../../../components/Modal";
import { ReactComponent as CloseIcon } from "../../../assets/icons/x.svg";
import { BadgeImage } from "./BadgeImage";

export function AchievementDetailModal({ achievement, onClose }: { achievement: any; onClose: () => void }) {
    return (
        <Modal isOpen={!!achievement} handleModal={onClose} contentClassName="!w-[420px]">
            <div className="relative flex flex-col items-center gap-4 py-4">
                <button onClick={onClose} className="absolute -top-2 right-0" aria-label="Close">
                    <CloseIcon className="w-6 h-6" />
                </button>
                <BadgeImage iconUrl={achievement?.badge_icon_url} alt={achievement?.name} className="w-[96px] h-[96px]" />
                <div className="flex flex-col items-center gap-1 text-center">
                    <span className="text-lg font-semibold text-black">{achievement?.name}</span>
                    {achievement?.description && (
                        <span className="text-sm text-black">{achievement.description}</span>
                    )}
                </div>
            </div>
        </Modal>
    );
}
